import React from "react";
import "./AboutUs.css";
import { Container, Row, Col } from "react-bootstrap";
import { Map, ContactUs } from "../../Features/Home";
import { Header, Features } from "../../Features/About";

const AboutUs = ({ url, data }) => {

  const aboutSection = data?.find((item) => item.section === "About Section");

  const getInTouchSection = data?.find(
    (item) => item.section === "Get In Touch Section"
  );
  const ourWorldwidePresenceSection = data?.find(
    (item) => item.section === "Our Worldwide Presence Section"
  );


  return (
    <div className="about-container">
      <Container>
        <Header section={aboutSection} url={url} />
        <div className="buisness-div">
          <div className="about-title">
            <p
              dangerouslySetInnerHTML={{
                __html: aboutSection.data.about_subtitle,
              }}
            ></p>
            {/* Making <span style={{fontWeight:"700"}}>Telematics</span> Business Easier<span style={{color:"#239DAB"}}>!</span> */}
          </div>
        </div>
      </Container>
      <Features url={url} section={aboutSection} />
      <Container>
        {ourWorldwidePresenceSection && (
          <Map url={url} section={ourWorldwidePresenceSection} />
        )}
      </Container>
      {getInTouchSection && <ContactUs url={url} section={getInTouchSection} />}
    </div>
  );
};

export default AboutUs;
